import {
  APIAgentEvent,
  APIAgentSession,
  APIGetAllHgrRequest,
  APIHgr,
  APIHgrEntityStagesWithTask,
  APISendMessageRequest,
  PaginationMetadata,
  SortOrder,
} from "@/services/api/api.types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../store";
import {
  APIGetGroupTerminationConversation,
  APIGetGroupTerminationUserSessions,
  APISendGroupTerminationMessage,
} from "@/services/api/api.ai-agent";

export interface GroupTerminationAgentState {
  groupTerminationUserSessions: APIAgentSession[] | null;
  isFetchingGroupTerminationUserSessions?: boolean;
  selectedGroupTerminationConversation: string | null;
  selectedGroupTerminationConversationMessages: APIAgentEvent[] | null;
  isLoadingSelectedGroupTerminationConversationMessages: boolean;
  isSendingGroupTerminationNewMessage: boolean;
}

export const initialState: GroupTerminationAgentState = {
  groupTerminationUserSessions: null,
  isFetchingGroupTerminationUserSessions: false,
  selectedGroupTerminationConversation: null,
  selectedGroupTerminationConversationMessages: [],
  isLoadingSelectedGroupTerminationConversationMessages: false,
  isSendingGroupTerminationNewMessage: false,
};
export const groupTerminationAgentSlice = createSlice({
  name: "groupTerminationAgent",
  initialState,
  reducers: {
    setIsFetchingGroupTerminationUserSessions: (
      state: GroupTerminationAgentState,
      action: PayloadAction<boolean>
    ) => {
      state.isFetchingGroupTerminationUserSessions = action.payload;
    },
    setGroupTerminationUserSessions: (
      state: GroupTerminationAgentState,
      action: PayloadAction<APIAgentSession[] | null>
    ) => {
      state.groupTerminationUserSessions = action.payload;
    },
    setSelectedGroupTerminationConversation: (
      state: GroupTerminationAgentState,
      action: PayloadAction<string | null>
    ) => {
      state.selectedGroupTerminationConversation = action.payload;
    },
    setSelectedGroupTerminationConversationMessages: (
      state: GroupTerminationAgentState,
      action: PayloadAction<APIAgentEvent[] | null>
    ) => {
      state.selectedGroupTerminationConversationMessages = action.payload;
    },
    setIsLoadingSelectedGroupTerminationConversationMessages: (
      state: GroupTerminationAgentState,
      action: PayloadAction<boolean>
    ) => {
      state.isLoadingSelectedGroupTerminationConversationMessages = action.payload;
    },
    setIsSendingGroupTerminationNewMessage: (
      state: GroupTerminationAgentState,
      action: PayloadAction<boolean>
    ) => {
      state.isSendingGroupTerminationNewMessage = action.payload;
    },
  },
});
export const getGroupTerminationUserSessions =
  (userId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setIsFetchingGroupTerminationUserSessions(true));
      const data = await APIGetGroupTerminationUserSessions(userId);
      console.log("[AI_CHAT data]", data);
      dispatch(setGroupTerminationUserSessions(data || []));
      dispatch(setIsFetchingGroupTerminationUserSessions(false));
    } catch (error) {
      dispatch(setIsFetchingGroupTerminationUserSessions(false));
      console.log("[ERROR e]", error);
    }
  };

export const getGroupTerminationSelectedConversationMessages =
  (conversationId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setIsLoadingSelectedGroupTerminationConversationMessages(true));
      const data = await APIGetGroupTerminationConversation(conversationId);
      console.log("[AI_CHAT data]", data);
      dispatch(setIsLoadingSelectedGroupTerminationConversationMessages(false));
      dispatch(setSelectedGroupTerminationConversationMessages(data || []));
    } catch (error) {
      console.log("[ERROR e]", error);
    }
  };

export const sendGroupTerminationNewMessage =
  (payload: APISendMessageRequest): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setIsSendingGroupTerminationNewMessage(true));
      const data = await APISendGroupTerminationMessage(payload);
      console.log("[AI_CHAT data]", data);
      dispatch(setIsSendingGroupTerminationNewMessage(false));
      dispatch(getGroupTerminationSelectedConversationMessages(data.session_id));
      dispatch(setSelectedGroupTerminationConversation(data.session_id));
      dispatch(getGroupTerminationUserSessions(data?.user_id));
    } catch (error) {
      dispatch(setIsSendingGroupTerminationNewMessage(false));
      console.log("[ERROR e]", error);
    }
  };

export const {
  setIsFetchingGroupTerminationUserSessions,
  setGroupTerminationUserSessions,
  setSelectedGroupTerminationConversation,
  setSelectedGroupTerminationConversationMessages,
  setIsLoadingSelectedGroupTerminationConversationMessages,
  setIsSendingGroupTerminationNewMessage,
} = groupTerminationAgentSlice.actions;
export default groupTerminationAgentSlice.reducer;
